import { render } from "./CASINoteSection.vue?vue&type=template&id=3ada0f20&scoped=true"
import script from "./CASINoteSection.vue?vue&type=script&lang=js"
export * from "./CASINoteSection.vue?vue&type=script&lang=js"

import "./CASINoteSection.vue?vue&type=style&index=0&id=3ada0f20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ada0f20"]])

export default __exports__